/**
 * Blocco newsletter di "Popup Newsletter Modulare" (section-newsletter-popup).
 *
 * Fa due cose che Liquid non può fare da solo:
 *
 * 1. Concatena data di nascita e tag del form in un unico contact[tags]. Shopify
 *    accetta un solo campo contact[tags], e la data è nota solo a runtime: il campo
 *    visibile del datepicker si chiama 'birthdate' (ignorato da Shopify) e questo
 *    componente tiene in sync l'hidden contact[tags] con "<data>,<tag>".
 *
 * 2. Riapre il modale al ritorno dal submit per mostrare il messaggio di successo.
 *    Serve perché il form customer fa submit nativo (la pagina si ricarica col modale
 *    chiuso) e perché form.posted_successfully? è true per *tutti* i form customer
 *    della pagina, footer incluso: il flag in sessionStorage dice quale form ha
 *    davvero inviato, così il popup non si apre dopo un'iscrizione dal footer.
 */
class NewsletterPopup extends HTMLElement {
  tagsInput; dateInput; tag; modalId;

  static STORAGE_KEY = 'newsletter-popup:posted';

  static selectors = {
    date: 'input-date input',
    tags: 'input[name="contact[tags]"]',
    submit: '[data-submit]'
  };

  connectedCallback() {
    this.tagsInput = this.querySelector(NewsletterPopup.selectors.tags);
    this.dateInput = this.querySelector(NewsletterPopup.selectors.date);
    this.tag = (this.dataset.tag || '').trim();
    this.modalId = this.dataset.modal;

    if (this.tagsInput != undefined) {
      // capture: gira prima del listener di submit che ThemeForm mette sul bottone
      this.addEventListener('click', this.handleClick, true);

      if (this.dateInput != undefined) {
        this.dateInput.addEventListener('change', this.syncTags);
        this.dateInput.addEventListener('blur', this.syncTags);
      }

      this.syncTags();
    }

    this.handlePosted();
  }

  handleClick = (e) => {
    if (e.target.closest(NewsletterPopup.selectors.submit) == undefined)
      return;

    this.syncTags();
    this.flagPosted();
  }

  /**
   * contact[tags] = "<data di nascita>,<tag del form>", saltando i valori vuoti.
   * Shopify separa i tag cliente per virgola.
   */
  syncTags = () => {
    if (this.tagsInput == undefined)
      return;

    const date = this.dateInput != undefined ? this.dateInput.value.trim() : '';

    this.tagsInput.value = [date, this.tag].filter(value => value !== '').join(',');
  }

  flagPosted = () => {
    try {
      sessionStorage.setItem(NewsletterPopup.STORAGE_KEY, this.modalId);
    } catch (e) {
      // sessionStorage non disponibile (Safari privato, storage pieno): al massimo
      // si perde la riapertura automatica, il messaggio di successo resta nel DOM.
    }
  }

  handlePosted = () => {
    if (this.dataset.posted == undefined || this.modalId == undefined)
      return;

    let flagged = null;
    try {
      flagged = sessionStorage.getItem(NewsletterPopup.STORAGE_KEY);
      if (flagged === this.modalId)
        sessionStorage.removeItem(NewsletterPopup.STORAGE_KEY);
    } catch (e) {
      return;
    }

    if (flagged !== this.modalId)
      return;

    const modal = this.closest('bs-modal');
    if (modal == undefined || window.bootstrap == undefined)
      return;

    // getOrCreateInstance: BSModal ha già istanziato il modale, non ne creiamo un altro.
    // L'apertura è forzata, quindi ignora "Riapri dopo chiusura" per definizione.
    bootstrap.Modal.getOrCreateInstance(modal).show();
  }
}
if (!window.customElements.get("newsletter-popup")) {
  window.customElements.define("newsletter-popup", NewsletterPopup);
}
